// import { useEffect, useState } from "react";
// import axios from "axios";
// import {
//   Box,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Typography,
//   Button,
//   CircularProgress,
// } from "@mui/material";

// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";

// import "./DeviceReports.css";
// import apiService from "../../../utils/apiservice";

// const API_URL = process.env.REACT_APP_API_DJANGO_URL;

// export default function DeviceReports() {
//   const [devices, setDevices] = useState([]);
//   const [sites, setSites] = useState([]);
// const [loading, setLoading] = useState(false);
//  const [customers, setCustomers] = useState([]);
// const [selectedCustomer, setSelectedCustomer] = useState("");

// // const [sites, setSites] = useState([]);
// const [selectedSite, setSelectedSite] = useState("");


//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);

//   const token = localStorage.getItem("accessToken");
//   const customerId = localStorage.getItem("customer_id");
//   const role = localStorage.getItem("role");
// const userId = localStorage.getItem("userId");

//   // 🔹 Fetch customer

//  useEffect(() => {

// // Customer Admin & Site Engineer
// if (role === "CA" || role === "SE") {
//   setSelectedCustomer(customerId);
//   return;
// }

//   const fetchCustomers = async () => {
//     try {
//       const response = await apiService.get(
//         `${API_URL}/api/get_customers/`,
//         {
//           data: {},
//         }
//       );

//       const customerData = response.data || [];

//       setCustomers(customerData);

//       if (customerData.length > 0) {
//         setSelectedCustomer(customerData[0].tb_customer_id);
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   fetchCustomers();
// }, [role, customerId]);

//   // fetch sites 


//   useEffect(() => {
//   const fetchSites = async () => {
//     try {
//       let siteData = [];

//       const config = {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           Accept: "application/json",
//           "Content-Type": "application/json",
//         },
//         data: {},
//       };

//       // ✅ SUPERVISOR
//       if (role === "S") {
//         const response = await axios.get(
//           `${API_URL}/api/supervisor_sites/${userId}/`,
//           config
//         );

//         siteData = (response.data.sites || []).map((s) => ({
//           asset_id: s.asset_id,
//           name: s.name,
//         }));
//       }

//       // ✅ SITE ENGINEER
//       else if (role === "SE") {
//         const response = await axios.get(
//           `${API_URL}/api/engineer_sites/${userId}/`,
//           config
//         );

//         siteData = (response.data.sites || []).map((s) => ({
//           asset_id: s.asset_id,
//           name: s.site_name,
//         }));
//       }

//       // ✅ SUPER ADMIN / CUSTOMER
//       else {
//         const response = await axios.get(
//           `${API_URL}/api/get_customer_sites/${selectedCustomer}/`,
//           config
//         );

//         siteData = response.data.data || [];
//       }

//       setSites(siteData);

//       // Default dropdown value
//       // ✅ Super Admin -> default ALL
// if (siteData.length > 0) {
//   setSelectedSite(siteData[0].asset_id);
// } else {
//   setSelectedSite("");
// }

//     } catch (error) {
//       console.error("Error fetching sites:", error);
//     }
//   };

// if (selectedCustomer) {
//   fetchSites();
// }
// }, [selectedCustomer, token, role, userId]);





//   useEffect(() => {
//   const fetchDevices = async () => {
//     setLoading(true);

//     try {
//       let deviceList = [];

//       // ================================
//       // ✅ SUPER ADMIN -> ALL DEVICES
//       // ================================
//      // ================================
// // ✅ SUPER ADMIN
// // ================================
// if (role === "SA") {

//   // Customer selected but Site not selected
//   if (!selectedSite) {
//     setDevices([]);
//     setLoading(false);
//     return;
//   }

//   // Fetch selected site's devices
//   const res = await axios.get(
//     `${API_URL}/api/site_devices/${selectedSite}/`,
//     {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     }
//   );

//   const siteDevices = res.data.devices || [];

//   deviceList = await Promise.all(
//     siteDevices.map(async (device, index) => {

//       let latitude = "-";
//       let longitude = "-";
//       let is_enabled = false;

//       try {
//         const attr = await axios.get(
//           `${API_URL}/api/device_attributes/${device.device_id}/`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         const attrs = attr.data.attributes || [];

//         latitude =
//           attrs.find((a) => a.key === "latitude")?.value || "-";

//         longitude =
//           attrs.find((a) => a.key === "longitude")?.value || "-";

//         is_enabled =
//           attrs.find((a) => a.key === "active")?.value || false;

//       } catch (err) {}

//       return {
//         id: index + 1,
//         device_name: device.device_name,
//         latitude,
//         longitude,
//         is_enabled,
//       };
//     })
//   );
// }

//       // ============================================
//       // ✅ SUPERVISOR / ENGINEER -> ASSIGNED DEVICES
//       // ============================================
//       else if (role === "S" || role === "SE") {

//         let assignedSites = [];

//         // ✅ Supervisor
//         if (role === "S") {

//           const res = await axios.get(
//             `${API_URL}/api/supervisor_sites/${userId}/`,
//             {
//               headers: {
//                 Authorization: `Bearer ${token}`,
//                 Accept: "application/json",
//               "Content-Type": "application/json",
//               },
//               data: {},
//             }
//           );

//           assignedSites = res.data.sites || [];
//         }

//         // ✅ Site Engineer
//         else if (role === "SE") {

//           const res = await axios.get(
//             `${API_URL}/api/engineer_sites/${userId}/`,
//             {
//               headers: {
//                 Authorization: `Bearer ${token}`,
//               },
//               data: {},
//             }
//           );

//           assignedSites = res.data.sites || [];
//         }

//         let allDevices = [];

//         // ✅ Fetch devices from assigned sites only
//         for (const site of assignedSites) {

//           try {
//             const res = await axios.get(
//               `${API_URL}/api/site_devices/${site.asset_id}/`,
//               {
//                 headers: {
//                   Authorization: `Bearer ${token}`,
//                 },
//               }
//             );

//             const siteDevices = res.data.devices || [];

//             allDevices.push(...siteDevices);

//           } catch (err) {
//             console.error("Error fetching site devices:", err);
//           }
//         }

//         deviceList = await Promise.all(
//           allDevices.map(async (device, index) => {

//             let latitude = "-";
//             let longitude = "-";
//             let is_enabled = false;

//             try {
//               const attr = await axios.get(
//                 `${API_URL}/api/device_attributes/${device.device_id}/`,
//                 {
//                   headers: {
//                     Authorization: `Bearer ${token}`,
//                   },
//                 }
//               );

//               const attrs = attr.data.attributes || [];

//               latitude =
//                 attrs.find((a) => a.key === "latitude")?.value || "-";

//               longitude =
//                 attrs.find((a) => a.key === "longitude")?.value || "-";

//               is_enabled =
//                 attrs.find((a) => a.key === "active")?.value || false;

//             } catch (err) {
//               console.error("Attribute fetch error:", err);
//             }

//             return {
//               id: index + 1,
//               device_name: device.device_name,
//               latitude,
//               longitude,
//               is_enabled,
//             };
//           })
//         );
//       }

//       // =====================================
//       // ✅ SINGLE SITE SELECTED
//       // =====================================
//       else {

//         const res = await axios.get(
//           `${API_URL}/api/site_devices/${selectedSite}/`,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//             },
//           }
//         );

//         const siteDevices = res.data.devices || [];

//         deviceList = await Promise.all(
//           siteDevices.map(async (device, index) => {

//             let latitude = "-";
//             let longitude = "-";
//             let is_enabled = false;

//             try {
//               const attr = await axios.get(
//                 `${API_URL}/api/device_attributes/${device.device_id}/`,
//                 {
//                   headers: {
//                     Authorization: `Bearer ${token}`,
//                   },
//                 }
//               );

//               const attrs = attr.data.attributes || [];

//               latitude =
//                 attrs.find((a) => a.key === "latitude")?.value || "-";

//               longitude =
//                 attrs.find((a) => a.key === "longitude")?.value || "-";

//               is_enabled =
//                 attrs.find((a) => a.key === "active")?.value || false;

//             } catch (err) {
//               console.error("Attribute fetch error:", err);
//             }

//             return {
//               id: index + 1,
//               device_name: device.device_name,
//               latitude,
//               longitude,
//               is_enabled,
//             };
//           })
//         );
//       }

//       setDevices(deviceList);

//     } catch (err) {

//       console.error("Error fetching devices:", err);
//       setDevices([]);

//     } finally {

//       setLoading(false);
//     }
//   };

//   if (selectedCustomer !== "") {
//   fetchDevices();
// }

// }, [selectedCustomer, selectedSite, role, userId]);



// const selectedCustomerName =
//   customers.find(
//     (c) => c.tb_customer_id === selectedCustomer
//   )?.customer_name || "Unknown Customer";

// const selectedSiteName =
//   sites.find((s) => s.asset_id === selectedSite)?.name || "Unknown Site";

//   // 🔹 CSV Export
//   const handleExportCSV = () => {
//     const headers = ["Sr No", "Device Name", "Latitude", "Longitude", "Status"];

//     const rows = devices.map((d, i) => [
//       i + 1,
//       d.device_name,
//       d.latitude,
//       d.longitude,
//       d.is_enabled ? "Active" : "Inactive",
//     ]);

//    const csvContent = [
//   [`Customer Name:,${selectedCustomerName}`],
//   [`Site Name:,${selectedSiteName}`],
//   [],
//   headers,
//   ...rows,
// ]
//       .map((e) => e.join(","))
//       .join("\n");

//     const csv = "data:text/csv;charset=utf-8," + csvContent;

//     const link = document.createElement("a");
//     link.href = encodeURI(csv);
//     link.download = `${selectedCustomerName}_${selectedSiteName}_device_report.csv`;
//     link.click();
//   };

//   // 🔹 PDF Export
//   const handleExportPDF = () => {
//     const doc = new jsPDF();

//     // Title
//     doc.setFontSize(16);
//     doc.text("Device Report", 14, 15);

//     // Site Name
//    doc.setFontSize(12);
// doc.text(`Customer Name: ${selectedCustomerName}`, 14, 25);
// doc.text(`Site Name: ${selectedSiteName}`, 14, 33);

// autoTable(doc, {
//   startY: 43,
//       head: [["Sr No", "Device Name", "Latitude", "Longitude", "Status"]],
//       body: devices.map((d, i) => [
//         i + 1,
//         d.device_name,
//         d.latitude,
//         d.longitude,
//         d.is_enabled ? "Active" : "Inactive",
//       ]),
//     });

//    doc.save(`${selectedCustomerName}_${selectedSiteName}_device_report.pdf`);
//   };

//   return (
//     <Box className="report-container">
//       {/* HEADER */}
//       {/* TOP BAR */}
//       <Box className="top-bar">

//        {role !== "CA" && role !== "SE" && (
//   <FormControl className="dropdown">
//     <InputLabel>Select Customer</InputLabel>

//     <Select
//       value={selectedCustomer}
//       label="Select Customer"
//       onChange={(e) => {
//         setSelectedCustomer(e.target.value);
//         setSelectedSite("");
//         setDevices([]);
//       }}
//     >
//       {customers.map((customer) => (
//         <MenuItem
//           key={customer.tb_customer_id}
//           value={customer.tb_customer_id}
//         >
//           {customer.customer_name}
//         </MenuItem>
//       ))}
//     </Select>
//   </FormControl>
// )}
//        <FormControl className="dropdown">
//   <InputLabel>Select Site</InputLabel>

//   <Select
//     value={selectedSite}
//     label="Select Site"
//     onChange={(e) => setSelectedSite(e.target.value)}
//   >
//     {sites.map((site) => (
//       <MenuItem
//         key={site.asset_id}
//         value={site.asset_id}
//       >
//         {site.name}
//       </MenuItem>
//     ))}
//   </Select>
// </FormControl>

//         <Box className="export-buttons">
//           <Button onClick={handleExportCSV} className="btn-csv">
//             CSV
//           </Button>

//           <Button onClick={handleExportPDF} className="btn-pdf">
//             PDF
//           </Button>
//         </Box>
//       </Box>

//       {/* SITE DROPDOWN */}
//       {/* <FormControl className="dropdown">
//         <InputLabel>Select Site</InputLabel>
//         <Select
//           value={selectedSite}
//           onChange={(e) => setSelectedSite(e.target.value)}
//         >
//           <MenuItem value="all">All</MenuItem>
//           {sites.map((s) => (
//             <MenuItem key={s.site_id} value={s.asset_id}>
//               {s.name}
//             </MenuItem>
//           ))}
//         </Select>
//       </FormControl> */}

//       {/* TABLE */}
//       <TableContainer component={Paper} className="table">
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>Sr No</TableCell>
//               <TableCell>Device Name</TableCell>
//               <TableCell>Latitude</TableCell>
//               <TableCell>Longitude</TableCell>
//               <TableCell>Status</TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {loading ? (
//               <TableRow>
//                 <TableCell colSpan={5} align="center">
//                   <CircularProgress />
//                 </TableCell>
//               </TableRow>
//             ) : devices.length === 0 ? (
//               <TableRow>
//                 <TableCell colSpan={5} align="center">
//                   No Data
//                 </TableCell>
//               </TableRow>
//             ) : (
//               devices.slice(page * 5, page * 5 + 5).map((d, i) => (
//                 <TableRow key={i}>
//                   <TableCell>{i + 1}</TableCell>
//                   <TableCell>{d.device_name}</TableCell>
//                   <TableCell>{d.latitude}</TableCell>
//                   <TableCell>{d.longitude}</TableCell>
//                   <TableCell>
//                     <span
//                       style={{
//                         color: d.is_enabled ? "green" : "red",
//                         fontWeight: "bold",
//                       }}
//                     >
//                       {d.is_enabled ? "Active" : "Inactive"}
//                     </span>
//                   </TableCell>
//                 </TableRow>
//               ))
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>
//     </Box>
//   );
// }


import { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import "./DeviceReports.css";
import apiService from "../../../utils/apiservice";

const API_URL = process.env.REACT_APP_API_DJANGO_URL;

export default function DeviceReports() {
  const [devices, setDevices] = useState([]);
  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");


  // const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");


  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const token = localStorage.getItem("accessToken");
  const customerId = localStorage.getItem("customer_id");
  const role = localStorage.getItem("role");
  const userId = localStorage.getItem("userId");

  // 🔹 Fetch customer

  useEffect(() => {

    // Customer Admin & Site Engineer
    if (role === "CA" || role === "SE" || role === "DC") {
      setSelectedCustomer(customerId);
      return;
    }

    const fetchCustomers = async () => {
      try {
        const response = await apiService.get(
          `${API_URL}/api/get_customers/`,
          {
            data: {},
          }
        );

        const customerData = response.data || [];

        setCustomers(customerData);

        if (customerData.length > 0) {
          setSelectedCustomer(customerData[0].tb_customer_id);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchCustomers();
  }, [role, customerId]);

  // fetch sites 


  useEffect(() => {
    const fetchSites = async () => {
      try {
        let siteData = [];

        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: {},
        };

        // ✅ SUPERVISOR
        if (role === "S") {
          const response = await axios.get(
            `${API_URL}/api/supervisor_sites/${userId}/`,
            config
          );

          siteData = (response.data.sites || []).map((s) => ({
            asset_id: s.asset_id,
            name: s.name,
          }));
        }

        // ✅ SITE ENGINEER
        else if (role === "SE") {
          const response = await axios.get(
            `${API_URL}/api/engineer_sites/${userId}/`,
            config
          );

          siteData = (response.data.sites || []).map((s) => ({
            asset_id: s.asset_id,
            name: s.site_name,
          }));
        }

        // ✅ SUPER ADMIN / CUSTOMER
        else {
          const response = await axios.get(
            `${API_URL}/api/get_customer_sites/${selectedCustomer}/`,
            config
          );

          siteData = response.data.data || [];
        }

        setSites(siteData);

        // Default dropdown value
        // ✅ Super Admin -> default ALL
        if (siteData.length > 0) {
          setSelectedSite(siteData[0].asset_id);
        } else {
          setSelectedSite("");
        }

      } catch (error) {
        console.error("Error fetching sites:", error);
      }
    };

    if (selectedCustomer) {
      fetchSites();
    }
  }, [selectedCustomer, token, role, userId]);





  useEffect(() => {
    const fetchDevices = async () => {
      setLoading(true);

      try {
        let deviceList = [];

        // ================================
        // ✅ SUPER ADMIN -> ALL DEVICES
        // ================================
        // ================================
        // ✅ SUPER ADMIN
        // ================================
        if (role === "SA") {

          // Customer selected but Site not selected
          if (!selectedSite) {
            setDevices([]);
            setLoading(false);
            return;
          }

          // Fetch selected site's devices
          const res = await axios.get(
            `${API_URL}/api/site_devices/${selectedSite}/`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          const siteDevices = res.data.devices || [];

          deviceList = await Promise.all(
            siteDevices.map(async (device, index) => {

              let latitude = "-";
              let longitude = "-";
              let is_enabled = false;

              try {
                const attr = await axios.get(
                  `${API_URL}/api/device_attributes/${device.device_id}/`,
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  }
                );

                const attrs = attr.data.attributes || [];

                latitude =
                  attrs.find((a) => a.key === "latitude")?.value || "-";

                longitude =
                  attrs.find((a) => a.key === "longitude")?.value || "-";

                is_enabled =
                  attrs.find((a) => a.key === "active")?.value || false;

              } catch (err) { }

              return {
                id: index + 1,
                device_name: device.device_name,
                latitude,
                longitude,
                is_enabled,
              };
            })
          );
        }

        // ============================================
        // ✅ SUPERVISOR / ENGINEER -> ASSIGNED DEVICES
        // ============================================
        else if (role === "S" || role === "SE") {

          let assignedSites = [];

          // ✅ Supervisor
          if (role === "S") {

            const res = await axios.get(
              `${API_URL}/api/supervisor_sites/${userId}/`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
                data: {},
              }
            );

            assignedSites = res.data.sites || [];
          }

          // ✅ Site Engineer
          else if (role === "SE") {

            const res = await axios.get(
              `${API_URL}/api/engineer_sites/${userId}/`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
                data: {},
              }
            );

            assignedSites = res.data.sites || [];
          }

          // let allDevices = [];

          // // ✅ Fetch devices from assigned sites only
          // for (const site of assignedSites) {

          //   try {
          //     const res = await axios.get(
          //       `${API_URL}/api/site_devices/${site.asset_id}/`,
          //       {
          //         headers: {
          //           Authorization: `Bearer ${token}`,
          //         },
          //       }
          //     );

          //     const siteDevices = res.data.devices || [];

          //     allDevices.push(...siteDevices);

          //   } catch (err) {
          //     console.error("Error fetching site devices:", err);
          //   }
          // }
          let allDevices = [];

          // If site selected → fetch only that site
          const sitesToFetch = selectedSite
            ? assignedSites.filter((site) => site.asset_id === selectedSite)
            : assignedSites;

          // Fetch devices
          for (const site of sitesToFetch) {
            try {
              const res = await axios.get(
                `${API_URL}/api/site_devices/${site.asset_id}/`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              );

              const siteDevices = res.data.devices || [];
              allDevices.push(...siteDevices);

            } catch (err) {
              console.error("Error fetching site devices:", err);
            }
          }

          deviceList = await Promise.all(
            allDevices.map(async (device, index) => {

              let latitude = "-";
              let longitude = "-";
              let is_enabled = false;

              try {
                const attr = await axios.get(
                  `${API_URL}/api/device_attributes/${device.device_id}/`,
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  }
                );

                const attrs = attr.data.attributes || [];

                latitude =
                  attrs.find((a) => a.key === "latitude")?.value || "-";

                longitude =
                  attrs.find((a) => a.key === "longitude")?.value || "-";

                is_enabled =
                  attrs.find((a) => a.key === "active")?.value || false;

              } catch (err) {
                console.error("Attribute fetch error:", err);
              }

              return {
                id: index + 1,
                device_name: device.device_name,
                latitude,
                longitude,
                is_enabled,
              };
            })
          );
        }

        // =====================================
        // ✅ SINGLE SITE SELECTED
        // =====================================
        else {

          const res = await axios.get(
            `${API_URL}/api/site_devices/${selectedSite}/`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          const siteDevices = res.data.devices || [];

          deviceList = await Promise.all(
            siteDevices.map(async (device, index) => {

              let latitude = "-";
              let longitude = "-";
              let is_enabled = false;

              try {
                const attr = await axios.get(
                  `${API_URL}/api/device_attributes/${device.device_id}/`,
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  }
                );

                const attrs = attr.data.attributes || [];

                latitude =
                  attrs.find((a) => a.key === "latitude")?.value || "-";

                longitude =
                  attrs.find((a) => a.key === "longitude")?.value || "-";

                is_enabled =
                  attrs.find((a) => a.key === "active")?.value || false;

              } catch (err) {
                console.error("Attribute fetch error:", err);
              }

              return {
                id: index + 1,
                device_name: device.device_name,
                latitude,
                longitude,
                is_enabled,
              };
            })
          );
        }

        setDevices(deviceList);

      } catch (err) {

        console.error("Error fetching devices:", err);
        setDevices([]);

      } finally {

        setLoading(false);
      }
    };

    // if (selectedCustomer !== "") {
    //   fetchDevices();
    // }
    if (
      selectedCustomer !== "" &&
      (role !== "SE" || selectedSite !== "")
    ) {
      fetchDevices();
    }

  }, [selectedCustomer, selectedSite, role, userId]);



  const selectedCustomerName =
    customers.find(
      (c) => c.tb_customer_id === selectedCustomer
    )?.customer_name || "Unknown Customer";

  const selectedSiteName =
    sites.find((s) => s.asset_id === selectedSite)?.name || "Unknown Site";

  // 🔹 CSV Export
  const handleExportCSV = () => {
    const headers = ["Sr No", "Device Name", "Latitude", "Longitude", "Status"];

    const rows = devices.map((d, i) => [
      i + 1,
      d.device_name,
      d.latitude,
      d.longitude,
      d.is_enabled ? "Active" : "Inactive",
    ]);

    const csvContent = [
      // [`Customer Name:,${selectedCustomerName}`],
      ...(role !== "CA" && role !== "SE" && role !== "DC"
        ? [[`Customer Name:,${selectedCustomerName}`]]
        : []),
      [`Site Name:,${selectedSiteName}`],
      [],
      headers,
      ...rows,
    ]
      .map((e) => e.join(","))
      .join("\n");

    const csv = "data:text/csv;charset=utf-8," + csvContent;

    const link = document.createElement("a");
    link.href = encodeURI(csv);
    // link.download = `${selectedCustomerName}_${selectedSiteName}_device_report.csv`;
    link.download =
  role !== "CA" && role !== "SE" && role !== "DC"
    ? `${selectedCustomerName}_${selectedSiteName}_device_report.csv`
    : `${selectedSiteName}_device_report.csv`;
    link.click();
  };

  // 🔹 PDF Export
  const handleExportPDF = () => {
    const doc = new jsPDF();

    // Title
    doc.setFontSize(16);
    doc.text("Device Report", 14, 15);

    // Site Name
    doc.setFontSize(12);
    // doc.text(`Customer Name: ${selectedCustomerName}`, 14, 25);
    // doc.text(`Site Name: ${selectedSiteName}`, 14, 33);

    // autoTable(doc, {
    //   startY: 43,
    let y = 25;

    if (role !== "CA" && role !== "SE" && role !== "DC") {
      doc.text(`Customer Name: ${selectedCustomerName}`, 14, y);
      y += 8;
    }

    doc.text(`Site Name: ${selectedSiteName}`, 14, y);

    autoTable(doc, {
      startY: y + 10,
      head: [["Sr No", "Device Name", "Latitude", "Longitude", "Status"]],
      body: devices.map((d, i) => [
        i + 1,
        d.device_name,
        d.latitude,
        d.longitude,
        d.is_enabled ? "Active" : "Inactive",
      ]),
    });

    // doc.save(`${selectedCustomerName}_${selectedSiteName}_device_report.pdf`);
    doc.save(
  role !== "CA" && role !== "SE" && role !== "DC"
    ? `${selectedCustomerName}_${selectedSiteName}_device_report.pdf`
    : `${selectedSiteName}_device_report.pdf`
);
  };

  return (
    <Box className="report-container">
      {/* HEADER */}
      {/* TOP BAR */}
      <Box className="top-bar">

        {role !== "CA" && role !== "SE" && role !== "DC" && (
          <FormControl className="dropdown">
            <InputLabel>Select Customer</InputLabel>

            <Select
              value={selectedCustomer}
              label="Select Customer"
              onChange={(e) => {
                setSelectedCustomer(e.target.value);
                setSelectedSite("");
                setDevices([]);
              }}
            >
              {customers.map((customer) => (
                <MenuItem
                  key={customer.tb_customer_id}
                  value={customer.tb_customer_id}
                >
                  {customer.customer_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <FormControl className="dropdown">
          <InputLabel>Select Site</InputLabel>

          <Select
            value={selectedSite}
            label="Select Site"
            onChange={(e) => setSelectedSite(e.target.value)}
          >
            {sites.map((site) => (
              <MenuItem
                key={site.asset_id}
                value={site.asset_id}
              >
                {site.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box className="export-buttons">
          <Button onClick={handleExportCSV} className="btn-csv">
            CSV
          </Button>

          <Button onClick={handleExportPDF} className="btn-pdf">
            PDF
          </Button>
        </Box>
      </Box>

      {/* SITE DROPDOWN */}
      {/* <FormControl className="dropdown">
        <InputLabel>Select Site</InputLabel>
        <Select
          value={selectedSite}
          onChange={(e) => setSelectedSite(e.target.value)}
        >
          <MenuItem value="all">All</MenuItem>
          {sites.map((s) => (
            <MenuItem key={s.site_id} value={s.asset_id}>
              {s.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl> */}

      {/* TABLE */}
      <TableContainer component={Paper} className="table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sr No</TableCell>
              <TableCell>Device Name</TableCell>
              <TableCell>Latitude</TableCell>
              <TableCell>Longitude</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : devices.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No Data
                </TableCell>
              </TableRow>
            ) : (
              devices.slice(page * 5, page * 5 + 5).map((d, i) => (
                <TableRow key={i}>
                  <TableCell>{i + 1}</TableCell>
                  <TableCell>{d.device_name}</TableCell>
                  <TableCell>{d.latitude}</TableCell>
                  <TableCell>{d.longitude}</TableCell>
                  <TableCell>
                    <span
                      style={{
                        color: d.is_enabled ? "green" : "red",
                        fontWeight: "bold",
                      }}
                    >
                      {d.is_enabled ? "Active" : "Inactive"}
                    </span>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}